import { useState } from 'react'
import ClickAwayListener from 'react-click-away-listener'
import { IconButton, Tooltip } from '@material-tailwind/react'
import { LiaSatelliteSolid } from 'react-icons/lia'
import { PiSun, PiStackSimple, PiCubeDuotone, PiMoon } from 'react-icons/pi'
import { useTranslation } from 'react-i18next'
import { useFeatureAuth } from '../hooks/authorization'
import { useUserPreferences } from '../contexts/UserPreferencesContext'
import { FEATURES } from '../utils/constants/features.constants'
import { basicControlStyle, activeControlStyle, inactiveControlStyle } from '../style/tailwindClasses'
import { useDarkMode } from '../contexts/DarkModeContext'

const MapStyleSelector: React.FC = () => {
  const { t } = useTranslation()
  const { darkMode } = useDarkMode()
  const [showOpts, setShowOpts] = useState(false)
  const { mapStyle, setMapStyle, apply3DMap, setApply3DMap } = useUserPreferences()
  const advancedMapStyles = useFeatureAuth(FEATURES.ADVANCED_MAP_STYLES)
  return (
    <div className="flex flex-col gap-2">
      <ClickAwayListener onClickAway={() => setShowOpts(false)}>
        <div className="relative z-10">
          {showOpts && (
            <div className="flex flex-col gap-3 mb-3" data-testid="map-style-options">
              <Tooltip content={t('mapStyle.vectorMode')} placement="right">
                <IconButton
                  size="md"
                  color="white"
                  className={`${basicControlStyle} ${mapStyle === 'vector' ? activeControlStyle : inactiveControlStyle}`}
                  onClick={() => setMapStyle('vector')}
                  data-testid="map-style-option-vector"
                >
                  {darkMode ? (
                    <PiMoon className="h-4 w-4 md:h-5 md:w-5" />
                  ) : (
                    <PiSun className="h-4 w-4 md:h-5 md:w-5" />
                  )}
                </IconButton>
              </Tooltip>
              {Boolean(advancedMapStyles) && (
                <Tooltip content={t('mapStyle.satelliteMode')} placement="right">
                  <IconButton
                    size="md"
                    color="white"
                    className={`${basicControlStyle} ${mapStyle === 'satellite' ? activeControlStyle : inactiveControlStyle}`}
                    onClick={() => setMapStyle('satellite')}
                    data-testid="map-style-option-satellite"
                  >
                    <LiaSatelliteSolid className="h-4 w-4 md:h-5 md:w-5" />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          )}

          <Tooltip content={t('mapStyle.changeMapStyle')} placement="right">
            <IconButton
              size="md"
              className={`${basicControlStyle} ${showOpts ? activeControlStyle : inactiveControlStyle}`}
              color="white"
              onClick={() => setShowOpts((prev) => !prev)}
              data-testid="map-style-toggle"
            >
              <PiStackSimple className="w-4 h-4" />
            </IconButton>
          </Tooltip>
        </div>
      </ClickAwayListener>

      <Tooltip content={t('mapStyle.use3DData')} placement="right">
        <IconButton
          size="md"
          className={`${basicControlStyle} ${apply3DMap ? activeControlStyle : inactiveControlStyle}`}
          onClick={() => setApply3DMap(!apply3DMap)}
          color="white"
          data-testid="map-style-3d-toggle"
        >
          <PiCubeDuotone className="w-4 h-4" />
        </IconButton>
      </Tooltip>
    </div>
  )
}

export default MapStyleSelector
